"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAssignAgentToEnquiryBodyDto = instanceOfAssignAgentToEnquiryBodyDto;
exports.AssignAgentToEnquiryBodyDtoFromJSON = AssignAgentToEnquiryBodyDtoFromJSON;
exports.AssignAgentToEnquiryBodyDtoFromJSONTyped = AssignAgentToEnquiryBodyDtoFromJSONTyped;
exports.AssignAgentToEnquiryBodyDtoToJSON = AssignAgentToEnquiryBodyDtoToJSON;
exports.AssignAgentToEnquiryBodyDtoToJSONTyped = AssignAgentToEnquiryBodyDtoToJSONTyped;
/**
 * Check if a given object implements the AssignAgentToEnquiryBodyDto interface.
 */
function instanceOfAssignAgentToEnquiryBodyDto(value) {
    if (!('enquiryId' in value) || value['enquiryId'] === undefined)
        return false;
    if (!('agentId' in value) || value['agentId'] === undefined)
        return false;
    return true;
}
function AssignAgentToEnquiryBodyDtoFromJSON(json) {
    return AssignAgentToEnquiryBodyDtoFromJSONTyped(json, false);
}
function AssignAgentToEnquiryBodyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'enquiryId': json['enquiryId'],
        'agentId': json['agentId'],
    };
}
function AssignAgentToEnquiryBodyDtoToJSON(json) {
    return AssignAgentToEnquiryBodyDtoToJSONTyped(json, false);
}
function AssignAgentToEnquiryBodyDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'enquiryId': value['enquiryId'],
        'agentId': value['agentId'],
    };
}
